// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03640383","239":"5e821e87","455":"0f8ebe09","488":"09d917e0"}[chunkId] + ".chunk.js";
};